module.exports = "<div class=\"language\" [ngClass]=\"{ 'open': languageDropdownOpened }\">\n\t<span (click)=\"languageDropdownOpened = !languageDropdownOpened\">\n    {{ currentLang }} <img src=\"assets/images/ico-arrow.svg\">\n  </span>\n\n\t<ul class=\"dropdown\">\n\t\t<li *ngFor=\"let lang of langsAvailable\" (click)=\"useLanguage(lang.code)\">\n\t\t\t{{ lang.name }}\n\t\t</li>\n\t</ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/translation/components/language-dropdown/language-dropdown.component.html
// module id = ./src/app/translation/components/language-dropdown/language-dropdown.component.html
// module chunks = main